var login = {
    init:function($params){
        var $getAgentUI = btoa(libs.getAgentUI());
        if($params && $params.email){
            $(".form-login form input[name='email']").val($params.email);
            $(".form-login .text-register").unbind().click(function(){
                window.history.pushState(null, null, '/signup');
                libs.render("/signup", 'login', 'signup', $params, 'POST');
            });
            $(".form-login form .forgot-password-link").unbind().click(function(){
                window.history.pushState(null, null, '/forgot/password');
                libs.render("/forgot/password", 'login', 'forgot_password', $params, 'POST');
            });
        }else{
            $(".form-login .text-register").unbind().click(function(){
                router.navigate('/signup');
            });
            $(".form-login form .forgot-password-link").unbind().click(function(){
                router.navigate('/forgot/password');
            });
            $(".form-login form .send-validation-link").unbind().click(function(){
                var $email = $('.form-login input[name="email"]').val();
                var $password = $('.form-login input[name="password"]').val();
                $params = {email:$email,password:$password};
                $.ajax({
                    url: "/login/validation",
                    method: "POST",
                    dataType: "json",
                    data: $params,
                    success: function ($data) {
                        libs.expire($data);
                        libs.render("/signup/welcome", 'login', 'signup_welcome', $data.data, 'POST');
                    }
                });
            });
        }
        login.login_validate(function($form){
            var $remember = $(".form-login form .form-check-input").prop('checked');
            var $params = $.extend({}, libs.getObjForm($form), {remember:$remember});
            $.ajax({
                url:"/login/request",
                method: "POST",
                dataType: "json",
                data:$params,
                success: function ($data) {
                    libs.expire($data);
                    $(".form-login .send-validation-link-wrapper").hide();
                    var $validator = $(".form-login form").validate();
                    var $errors;
                    switch ($data.status){
                        case 'success':
                            if($remember) {
                                Cookies.set($getAgentUI, btoa($params.email) + '.' + $data.data.token + libs.lock($params.password));
                                window.location = '/';
                            }else{
                                Cookies.remove($getAgentUI);
                                window.location = '/';
                            }
                            break;
                        case 'emailError':
                            $errors = {"email": "Invalid email"};
                            break;
                        case 'passwordError':
                            $errors = {"password": "Invalid password"};
                            break;
                        case 'needValidation':
                            $errors = {"email": "This email has not been validated yet."};
                            $(".form-login .send-validation-link-wrapper").show();
                            break;
                        case 'accountBlocked':
                            $errors = {"email": "This account is blocked"};
                            break;
                        case 'invalid':
                            $errors = {"email": "Invalid Account"};
                            break;
                    }
                    if($errors){
                        $validator.showErrors($errors);
                    }
                }
            });
        });
        var $cookie = Cookies.get($getAgentUI) != undefined ? Cookies.get($getAgentUI) : null;
        if($cookie){
            $.ajax({
                url:"/login/decode",
                method: "POST",
                dataType: "json",
                data:{cookie:$cookie},
                success: function ($data) {
                    libs.expire($data);
                    if(
                        $data.status == 'success' && $data.data.credential.remember
                    ){
                        try {
                            $(".form-login input[name='email']").val($data.data.credential.email);
                            $(".form-login input[name='password']").val(libs.unlock($data.data.credential.password));
                            $("#check-me-out").prop('checked', $data.data.credential.remember);
                        }catch (e) {

                        }
                    }else{
                        $("#check-me-out").prop('checked', false);
                        Cookies.remove($getAgentUI);
                        location.reload();
                    }
                }
            });
        }
        $("#check-me-out").unbind().change(function(){
            if(!$(this).is(":checked")){
                $(".form-login input[name='email']").val('');
                $(".form-login input[name='password']").val('');
                Cookies.remove($getAgentUI);
            }
        });
    },
    login_validate:function(cback){
        var $validator;
        try {
            $validator = $(".form-login form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $(".form-login form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                email: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                    email:true
                },
                password: {
                    required: true,
                    minlength: 3,
                    maxlength: 191
                }
            },
            messages: {
                email: {
                    required: "The email is required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid"
                },
                password: {
                    required: "The password is required",
                    minlength: "The password must have at least 3 characters",
                    maxlength: "The password cannot exceed 191 characters"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    signup:function(){
        login.signup_validate(function($form){
            login.signup_request(libs.getObjForm($form));
        });
        $(".form-signup form .reg-step1").show();
        $(".form-signup form .reg-step1 .create").unbind().click(function(){
            $(this).submit();
        }).show();
        $(".form-signup form .reg-step1 .back-to-login").unbind().click(function(){
            router.navigate('/login');
        }).show();
    },
    signup_validate:function(cback){
        var $validator;
        try {
            $validator = $(".form-signup form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $(".form-signup form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                email: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                    email:true,
                    remote: {
                        url: "/signup/email/exist",
                        type: "post",
                        data: {
                            email: function(){ return $(".form-signup form input[name='email']").val(); }
                        }
                    }
                },
                firstName: {
                    required: true,
                    maxlength: 191
                },
                lastName: {
                    required: true,
                    maxlength: 191
                },
                password: {
                    required: true,
                    minlength: 8,
                    maxlength: 191
                },
                profile: {
                    required: true
                }
            },
            messages: {
                email: {
                    required: "The email is required",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid",
                    remote:"The email exist, choose another"
                },
                firstName: {
                    required: "The first name is required",
                    maxlength: "The first name cannot exceed 191 characters"
                },
                lastName: {
                    required: "The last name is required",
                    minlength: "The last name must have at least 3 characters",
                    maxlength: "The last name cannot exceed 191 characters"
                },
                password: {
                    required: "The password is required",
                    minlength: "The password must have at least 8 characters",
                    maxlength: "The password cannot exceed 191 characters"
                },
                profile: {
                    required: "The profile is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    signup_request:function($data){
        libs.loading();
        $.ajax({
            url:"/signup/request",
            method: "POST",
            dataType: "json",
            data:$data,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    libs.render("/signup/welcome", 'login', 'signup_welcome', $data.data, 'POST');
                }
            }
        });
    },
    signup_welcome:function($params){
        $(".welcome .continue").unbind().click(function(){
            window.history.pushState(null, null, '/login');
            libs.render("/login", 'login', 'init', $params, 'POST');
        });
    },
    signup_validate_token:function($data){
        libs.memorySave('token', $data);
        login.signup_validate_token_validate(function($form) {
            var $data = libs.memoryGet('token');
            $data = $.extend($data, libs.getObjForm($form));
            libs.loading();
            $.ajax({
                url:"/signup/validate/request",
                method: "POST",
                dataType: "json",
                data:$data,
                success: function ($data) {
                    libs.expire($data);
                    if(
                        $data.status == 'success'
                    ){
                        router.navigate('/login');
                    }else{
                        window.location = '/';
                    }
                }
            });
        });
        $(".link-broken .continue").unbind().click(function(){
            router.navigate('/login');
        });
    },
    signup_validate_token_validate:function(cback){
        var $validator;
        try {
            $validator = $(".signup-validate form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $(".signup-validate form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                email: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                    email:true
                }
            },
            messages: {
                email: {
                    required: "The email is required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    forgot_password:function(){
        login.forgot_password_validate(function($form) {
            libs.loading();
            $.ajax({
                url:"/forgot/password/request",
                method: "POST",
                dataType: "json",
                data:libs.getObjForm($form),
                success: function ($data) {
                    libs.expire($data);
                    if(
                        $data.status == 'success'
                    ){
                        libs.render("/forgot/password/msg", 'login', 'forgot_password_msg', $data.data, 'POST');
                    }
                }
            });
        });
        $(".form-reset .back-to-login").unbind().click(function(){
            router.navigate('/login');
        });
    },
    forgot_password_msg:function($params){
        $(".forgot_password .continue").unbind().click(function(){
            router.navigate('/login');
        });
    },
    forgot_password_validate:function(cback){
        var $validator;
        try {
            $validator = $(".form-reset form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $(".form-reset form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                email: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                    email:true
                }
            },
            messages: {
                email: {
                    required: "The email is required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    forgot_password_validate_form:function(){
        login.forgot_password_validate_form_validate(function($form) {
            libs.loading();
            $.ajax({
                url:"/forgot/password/validate/request",
                method: "POST",
                dataType: "json",
                data:libs.getObjForm($form),
                success: function ($data) {
                    libs.expire($data);
                    if(
                        $data.status == 'success'
                    ){
                        router.navigate('/login');
                    }
                }
            });
        });
        $(".forgot-password .back-to-login").unbind().click(function(){
            router.navigate('/login');
        });
        $(".link-broken .continue").unbind().click(function(){
            router.navigate('/login');
        });
    },
    forgot_password_validate_form_validate:function(cback){
        var $validator;
        try {
            $validator = $(".forgot-password form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $(".forgot-password form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                email: {
                    required: true,
                    minlength: 3,
                    maxlength: 191,
                    email:true
                },
                newPassword: {
                    required: true,
                    minlength: 8,
                    maxlength: 191
                },
                retypeNewPassword: {
                    required: true,
                    equalTo: ".forgot-password form [name=newPassword]"
                }
            },
            messages: {
                email: {
                    required: "The email is required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid"
                },
                newPassword: {
                    required: "The new password is required",
                    minlength: "The new password must have at least 8 characters",
                    maxlength: "The new password cannot exceed 191 characters"
                },
                retypeNewPassword: {
                    required: "The retype password is required",
                    equalTo: "The retype password must be identical"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    privacy:function(){
        $("#content").css('height', 'auto');
        $(".login-wrapper .back-to-login").unbind().click(function(){
            $("#content").css('height', '1070px');
            router.navigate('/login');
        });
    },
};
